module.exports = {
  src: __webpack_public_path__ + "static/media/children_00017.cd425b12.jpg",
  width: 1664,
  height: 2496,
  bytes: 243047,
  type: "jpg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "static/media/children_00017.cd425b12.jpg";
};


//////////////////
// WEBPACK FOOTER
// ./src/core/images/galleries/children/children_00017.jpg
// module id = 215
// module chunks = 0